<template>
  <div class="app">
    <transition name="fade" mode="out-in">
      <router-view class="view"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
.view {
  transition: all .2s cubic-bezier(.55,0,.1,1);
}
</style>



// WEBPACK FOOTER //
// App.vue?76d02a8f